import React from 'react';
import ShareModal from './ShareModal';

interface PostShareModalProps {
    open: boolean;
    onClose: () => void;
    postId: string;
    title: string;
}

const PostShareModal: React.FC<PostShareModalProps> = ({ open, onClose, postId, title }) => {
    // Use production URL for sharing, fallback to current origin for development
    const baseUrl = process.env.NODE_ENV === 'production' 
        ? 'https://ifinds.in' // Replace with your actual production domain
        : window.location.origin.replace('https://', 'http://'); // Force HTTP for localhost
    const shareUrl = `${baseUrl}/post/${postId}`;
    const shareText = `Check out this post: ${title}`;

    return (
        <ShareModal
            open={open}
            onClose={onClose}
            title={title}
            shareUrl={shareUrl}
            shareText={shareText}
        />
    );
};

export default PostShareModal;